export default __webpack_public_path__ + "static/media/logo_agribank.7da07e93.png";